import axios from '../utils/axios';

// Report service functions — thin wrappers around axios instance
import { API_BASE_URL } from '../config/api';
import { axiosInstance } from '../config/api';
import { formatReportParams, validateRequiredParams } from '../utils/reportParams';



export async function getAppointmentTypes({ startDate, endDate, clinic_id, doctor_id }) {
	const url = '/api/reports/appointment-types';
	const params = { startDate, endDate };
	if (clinic_id != null) params.clinic_id = clinic_id;
	if (doctor_id != null) params.doctor_id = doctor_id;
	const { data } = await axios.get(url, { params });
	return data;
}

const BASE_URL = API_BASE_URL + "api/";;
// Bills report: revenue and refunds
// Expected params: { startDate, endDate, clinic_id, doctor_id }
// Expected response shape (recommended):
// {
//   success: true,
//   data: {
//     revenue: [{
//       month: "2023-01",
//       total: 12345.67,
//       paid: 12000.00,
//       unpaid: 345.67,
//     }],
//     refunds: [{
//       month: "2023-01",
//       total: 123,
//       incomplete: 23,
//       missed: 100.00
//     }]
//   }
// }


// export async function getBillsReport({ startDate, endDate, doctor_id, clinic_id } = {}) {
// 	const url = '/api/reports/bills';
// 	const params = { startDate, endDate };
// 	if (doctor_id != null) params.doctor_id = doctor_id;
// 	if (clinic_id != null) params.clinic_id = clinic_id;
// 	const { data } = await axios.get(url, { params });
// 	return data;
// }

export async function getActiveUsers({ startDate, endDate, clinic_id, doctor_id }) {
	const url = 'api/reports/active-users';
	const params = { startDate, endDate };
	if (clinic_id != null) params.clinic_id = clinic_id;
	if (doctor_id != null) params.doctor_id = doctor_id;
	const { data } = await axios.get(url, { params });
	return data;
}

export async function getNewUsers({ clinic_id, doctor_id }) {
	const url = 'api/reports/new-users';
	const params = {};
	if (clinic_id != null) params.clinic_id = clinic_id;
	if (doctor_id != null) params.doctor_id = doctor_id;
	const { data } = await axios.get(url, { params });
	return data;
}

export async function getPatientVisitFrequency({ startDate, endDate, doctor_id, clinic_id }) {
	const url = 'api/reports/patient-visit-frequency';
	const params = { startDate, endDate };
	if (doctor_id != null) params.doctor_id = doctor_id;
	if (clinic_id != null) params.clinic_id = clinic_id;
	const { data } = await axios.get(url, { params });
	return data;
}

export async function getPatientFollowup({ startDate, endDate, doctor_id, clinic_id }) {
	const url = 'api/reports/patient-followup';
	const params = { startDate, endDate };
	if (doctor_id != null) params.doctor_id = doctor_id;
	if (clinic_id != null) params.clinic_id = clinic_id;
	const { data } = await axios.get(url, { params });
	return data;
}

export async function getPatientDistribution({ startDate, endDate, doctor_id, clinic_id }) {
	const url = 'api/reports/patient-distribution';
	const params = { startDate, endDate };
	if (doctor_id != null) params.doctor_id = doctor_id;
	if (clinic_id != null) params.clinic_id = clinic_id;
	const { data } = await axios.get(url, { params });
	return data;
}

export async function getPatientGrowthTrends({ startDate, endDate, clinic_id, doctor_id }) {
	const url = 'api/reports/patient-growth-trends';
	const params = { startDate, endDate };
	if (clinic_id != null) params.clinic_id = clinic_id;
	if (doctor_id != null) params.doctor_id = doctor_id;
	const { data } = await axios.get(url, { params });
	return data;
}

export async function getVisitRepetitionReturn({ clinic_id, doctor_id }) {
	const url = 'api/reports/visit-repetition-return';
	const params = {};
	if (clinic_id != null) params.clinic_id = clinic_id;
	if (doctor_id != null) params.doctor_id = doctor_id;
	const { data } = await axios.get(url, { params });
	return data;
}

// Local/other base path used in collection examples
export async function getPatientRetention({ baseUrl, jwt } = {}) {
	// This endpoint in the collection uses a local server at /api/api/api/reports/patient-retention
	// When calling from the front-end, prefer the configured API_BASE_URL axios instance.
	const url = 'api/reports/patient-retention';
	const { data } = await axios.get(url);
	return data;
}

export default {
	getAppointmentTypes,
	getActiveUsers,
	getNewUsers,
	getPatientVisitFrequency,
	getPatientFollowup,
	getPatientDistribution,
	getPatientGrowthTrends,
	getVisitRepetitionReturn,
	getPatientRetention
};









/**
 * reportService - Wrapper for report related API calls
 *
 * Implements lightweight methods for common report endpoints used in the admin
 * views. Each method returns the response data or throws a descriptive error.
 */


// Track methods that have failed during this session. If a method is marked as failed
// we will skip further requests for that method until a full page reload clears this memory.
// const failedMethods = new Set();

// // Utility to clear failed methods (keeps API for debugging/testing)
// export const clearFailedMethods = () => failedMethods.clear();

// // Enhanced error handling with comprehensive categorization and retry logic
// const handleApiError = (error, methodName, params = {}, retryCount = 0) => {
// 	console.error(`Error in ${methodName}:`, error);

// 	// Categorize error for better handling
// 	const errorCategory = categorizeApiError(error);
// 	const isRetryable = isRetryableApiError(error, retryCount);

// 	// Extract meaningful error message based on category
// 	let userMessage = getUserFriendlyErrorMessage(error, methodName, errorCategory);
// 	let technicalMessage = error?.response?.data?.message || error?.message || 'Unknown error';

// 	// Create enhanced error object with comprehensive metadata
// 	const enhancedError = new Error(userMessage);
// 	enhancedError.originalError = error;
// 	enhancedError.method = methodName;
// 	enhancedError.status = error?.response?.status;
// 	enhancedError.code = error?.code;
// 	enhancedError.category = errorCategory;
// 	enhancedError.technicalMessage = technicalMessage;
// 	enhancedError.isRetryable = isRetryable;
// 	enhancedError.retryCount = retryCount;
// 	enhancedError.timestamp = new Date().toISOString();
// 	enhancedError.params = params;

// 	// Add recovery suggestions based on error type
// 	enhancedError.recoverySuggestions = getErrorRecoverySuggestions(errorCategory, params);

// 	// Log error details for monitoring
// 	logErrorForMonitoring(enhancedError, methodName);

// 	// Mark this method as failed so we skip repeated refetch attempts until a page reload.
// 	try {
// 		if (methodName) failedMethods.add(methodName);
// 	} catch (e) {
// 		// ignore
// 	}

// 	// Return the enhanced error object rather than throwing it directly.
// 	// Rationale: some callers call handleApiError(...) inside a catch block without re-throwing.
// 	// Throwing here produced uncaught promise rejections and bubbled to the top-level runtime overlay.
// 	// Returning the Error allows callers to decide whether to throw or handle the error gracefully.
// 	return enhancedError;
// };

// // Categorize API errors for better handling
// const categorizeApiError = (error) => {
// 	if (!error) return 'unknown';

// 	const status = error?.response?.status;
// 	const code = error?.code;
// 	const message = error?.message?.toLowerCase() || '';

// 	// Network connectivity errors
// 	if (code === 'NETWORK_ERROR' ||
// 		code === 'ERR_NETWORK' ||
// 		code === 'ERR_INTERNET_DISCONNECTED' ||
// 		message.includes('network error') ||
// 		!navigator.onLine) {
// 		return 'network';
// 	}

// 	// Authentication errors
// 	if (status === 401 || message.includes('unauthorized')) {
// 		return 'auth';
// 	}

// 	// Permission errors
// 	if (status === 403 || message.includes('forbidden') || message.includes('permission')) {
// 		return 'permission';
// 	}

// 	// Not found errors
// 	if (status === 404 || message.includes('not found')) {
// 		return 'not_found';
// 	}

// 	// Rate limiting
// 	if (status === 429 || message.includes('rate limit') || message.includes('too many requests')) {
// 		return 'rate_limit';
// 	}

// 	// Server errors
// 	if (status >= 500 || message.includes('server error') || message.includes('internal error')) {
// 		return 'server';
// 	}

// 	// Timeout errors
// 	if (code === 'ECONNABORTED' || code === 'ETIMEDOUT' || message.includes('timeout')) {
// 		return 'timeout';
// 	}

// 	// Validation errors
// 	if (status === 400 || message.includes('validation') || message.includes('invalid')) {
// 		return 'validation';
// 	}

// 	return 'unknown';
// };

// // Determine if error is retryable
// const isRetryableApiError = (error, retryCount = 0) => {
// 	const MAX_RETRIES = 3;

// 	if (retryCount >= MAX_RETRIES) return false;

// 	const category = categorizeApiError(error);
// 	const retryableCategories = ['network', 'timeout', 'server', 'rate_limit'];

// 	return retryableCategories.includes(category);
// };

// // Get user-friendly error messages
// const getUserFriendlyErrorMessage = (error, methodName, category) => {
// 	// Convert CamelCase method names to a readable phrase and remove a leading "get" if present
// 	let methodDisplayName = methodName.replace(/([A-Z])/g, ' $1').toLowerCase().trim();
// 	methodDisplayName = methodDisplayName.replace(/^get\s+/, ''); // "getPatientsVTF" -> "patients v t f"

// 	const messages = {
// 		network: `Unable to load ${methodDisplayName} data due to a network connection issue. Please check your internet connection and try again.`,
// 		auth: `Authentication required to access ${methodDisplayName} data. Please log in again.`,
// 		permission: `You don't have permission to view ${methodDisplayName} data. Contact your administrator if you believe you should have access.`,
// 		not_found: `No ${methodDisplayName} data found for the selected criteria. Try adjusting your filters or date range.`,
// 		rate_limit: `Too many requests. Please wait a moment before trying to load ${methodDisplayName} data again.`,
// 		server: `The server encountered an error while loading ${methodDisplayName} data. This is usually temporary - please try again in a few moments.`,
// 		timeout: `Loading ${methodDisplayName} data is taking longer than expected. This might be due to high server load or a slow connection.`,
// 		validation: `Invalid parameters provided for ${methodDisplayName} data. Please check your filter selections.`,
// 		unknown: `An unexpected error occurred while loading ${methodDisplayName} data.`,
// 	};

// 	return messages[category] || messages.unknown;
// };

// // Get recovery suggestions based on error category
// const getErrorRecoverySuggestions = (category, params = {}) => {
// 	const hasFilters = Object.keys(params).some(key =>
// 		key !== 'jwt' && params[key] !== undefined && params[key] !== ''
// 	);

// 	const suggestions = [];

// 	switch (category) {
// 		case 'network':
// 			suggestions.push('Check your internet connection');
// 			suggestions.push('Try refreshing the page');
// 			break;
// 		case 'auth':
// 			suggestions.push('Log in again');
// 			suggestions.push('Clear browser cache and cookies');
// 			break;
// 		case 'permission':
// 			suggestions.push('Contact your administrator for access');
// 			suggestions.push('Verify your account permissions');
// 			break;
// 		case 'not_found':
// 			if (hasFilters) {
// 				suggestions.push('Try expanding your date range');
// 				suggestions.push('Clear filters to see all available data');
// 			}
// 			suggestions.push('Verify data exists for the selected period');
// 			break;
// 		case 'rate_limit':
// 			suggestions.push('Wait a few moments before trying again');
// 			suggestions.push('Reduce the frequency of requests');
// 			break;
// 		case 'server':
// 			suggestions.push('Try again in a few moments');
// 			suggestions.push('Contact support if the issue persists');
// 			break;
// 		case 'timeout':
// 			suggestions.push('Check your network connection speed');
// 			suggestions.push('Try again with a more stable connection');
// 			break;
// 		case 'validation':
// 			if (hasFilters) {
// 				suggestions.push('Check your filter selections');
// 			}
// 			suggestions.push('Verify the date range is valid');
// 			break;
// 		default:
// 			suggestions.push('Try refreshing the page');
// 			suggestions.push('Contact support if the issue continues');
// 	}

// 	return suggestions;
// };

// // Log errors for monitoring and debugging
// const logErrorForMonitoring = (enhancedError, methodName) => {
// 	// Development logging
// 	if (process.env.NODE_ENV === 'development') {
// 		console.group(`🚨 API Error Report: ${methodName}`);
// 		console.error('Enhanced Error:', enhancedError);
// 		console.error('Original Error:', enhancedError.originalError);
// 		console.error('Category:', enhancedError.category);
// 		console.error('Is Retryable:', enhancedError.isRetryable);
// 		console.error('Recovery Suggestions:', enhancedError.recoverySuggestions);
// 		console.groupEnd();
// 	}

// 	// Report to external monitoring service if available
// 	if (window.reportError && typeof window.reportError === 'function') {
// 		try {
// 			window.reportError(enhancedError, {
// 				component: 'ReportService',
// 				method: methodName,
// 				category: enhancedError.category,
// 				isRetryable: enhancedError.isRetryable,
// 			});
// 		} catch (reportingError) {
// 			console.error('Failed to report error to monitoring service:', reportingError);
// 		}
// 	}

// 	// Report to analytics if available
// 	if (window.gtag && typeof window.gtag === 'function') {
// 		try {
// 			window.gtag('event', 'api_error', {
// 				method: methodName,
// 				category: enhancedError.category,
// 				status: enhancedError.status,
// 				is_retryable: enhancedError.isRetryable,
// 				retry_count: enhancedError.retryCount,
// 			});
// 		} catch (analyticsError) {
// 			console.error('Failed to report error to analytics:', analyticsError);
// 		}
// 	}
// };

// class ReportService {
// 	// Generic retry wrapper for API calls
// 	static async _withRetry(apiCall, methodName, params = {}, retryCount = 0) {
// 		try {
// 			return await apiCall();
// 		} catch (error) {
// 			// Check if error is retryable and we haven't exceeded max retries
// 			if (isRetryableApiError(error, retryCount)) {
// 				console.log(`🔄 Retrying ${methodName} (attempt ${retryCount + 1}/3)`);

// 				// Exponential backoff delay with jitter
// 				const baseDelay = Math.min(1000 * Math.pow(2, retryCount), 5000);
// 				const jitter = Math.random() * 500; // Add 0-500ms jitter
// 				const delay = baseDelay + jitter;

// 				await new Promise(resolve => setTimeout(resolve, delay));

// 				return this._withRetry(apiCall, methodName, params, retryCount + 1);
// 			}

// 			throw handleApiError(error, methodName, params, retryCount);
// 		}
// 	}
// 	static async getPatientDistribution(params = {}, userRole = null, userContext = {}, retryCount = 0) {
// 		if (failedMethods.has('getPatientDistribution')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientDistribution because it previously failed this session');
// 			return null;
// 		}
// 		let formattedParams;
// 		try {
// 			// Use enhanced parameter formatting if role is provided, otherwise use basic formatting
// 			formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);

// 			const resp = await axiosInstance.get(`${BASE_URL}reports/patient-distribution`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			// For patient distribution, treat "not found" as empty data rather than an error
// 			if (error?.response?.status === 404) {
// 				console.warn(`[ReportService] No patient distribution data found for params ${JSON.stringify(formattedParams)}, returning empty data`);
// 				return { ageDistribution: [], genderDistribution: [] };
// 			}

// 			// Check if error is retryable and we haven't exceeded max retries
// 			if (isRetryableApiError(error, retryCount)) {
// 				console.log(`🔄 Retrying getPatientDistribution (attempt ${retryCount + 1}/3)`);

// 				// Exponential backoff delay
// 				const delay = Math.min(1000 * Math.pow(2, retryCount), 5000);
// 				await new Promise(resolve => setTimeout(resolve, delay));

// 				return this.getPatientDistribution(params, userRole, userContext, retryCount + 1);
// 			}

// 			throw handleApiError(error, 'getPatientDistribution', formattedParams, retryCount);
// 		}
// 	}

// 	// Basic parameter formatting for backward compatibility
// 	static _basicFormatParams(params = {}) {
// 		const formatted = {};

// 		// Handle date parameters
// 		if (params.startDate) formatted.startDate = params.startDate;
// 		if (params.endDate) formatted.endDate = params.endDate;

// 		// Handle ID parameters - convert to numbers if they're strings
// 		if (params.clinic_id !== undefined && params.clinic_id !== '') {
// 			formatted.clinic_id = typeof params.clinic_id === 'string' ? parseInt(params.clinic_id, 10) : params.clinic_id;
// 		}
// 		if (params.doctor_id !== undefined && params.doctor_id !== '') {
// 			formatted.doctor_id = typeof params.doctor_id === 'string' ? parseInt(params.doctor_id, 10) : params.doctor_id;
// 		}

// 		return formatted;
// 	}

// 	// Legacy method for backward compatibility - uses doctor_Id param
// 	static async getPatientDistributionByDoctor(doctor_id = '') {
// 		if (failedMethods.has('getPatientDistributionByDoctor')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientDistributionByDoctor because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			const url = `${BASE_URL}reports/getPatientDistribution?doctor_Id=${encodeURIComponent(doctor_id)}`;
// 			const resp = await axiosInstance.get(url);
// 			return resp.data;
// 		} catch (error) {
// 			// For patient distribution, treat "not found" as empty data rather than an error
// 			if (error?.response?.status === 404) {
// 				console.warn(`[ReportService] No patient distribution data found for doctor ${doctor_id}, returning empty data`);
// 				return { ageDistribution: [], genderDistribution: [] };
// 			}
// 			throw handleApiError(error, 'getPatientDistributionByDoctor');
// 		}
// 	}

// 	// Legacy method for backward compatibility - uses clinic_id query param
// 	static async getPatientDistributionByClinic(clinic_id = '') {
// 		if (failedMethods.has('getPatientDistributionByClinic')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientDistributionByClinic because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			const url = `${BASE_URL}reports/getPatientDistribution?clinic_id=${encodeURIComponent(clinic_id)}`;
// 			const resp = await axiosInstance.get(url);
// 			return resp.data;
// 		} catch (error) {
// 			// For patient distribution, treat "not found" as empty data rather than an error
// 			if (error?.response?.status === 404) {
// 				console.warn(`[ReportService] No patient distribution data found for clinic ${clinic_id}, returning empty data`);
// 				return { ageDistribution: [], genderDistribution: [] };
// 			}
// 			throw handleApiError(error, 'getPatientDistributionByClinic');
// 		}
// 	}

// 	static async getPatientsVF(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getPatientsVF')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientsVF because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/patientsVF`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getPatientsVF');
// 		}
// 	}

// 	static async getPatientsVTF(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getPatientsVTF')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientsVTF because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/patientsVTF`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getPatientsVTF');
// 		}
// 	}

// 	static async getPatientRetention(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getPatientRetention')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientRetention because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/patient-retention`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getPatientRetention');
// 		}
// 	}

// 	static async getActiveUsers(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getActiveUsers')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getActiveUsers because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			validateRequiredParams(params, ['startDate', 'endDate']);
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/active-users`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getActiveUsers');
// 		}
// 	}

// 	static async getDashboardStats(params = {}, userRole = null, userContext = {}, retryCount = 0) {
// 		if (failedMethods.has('getDashboardStats')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getDashboardStats because it previously failed this session');
// 			return null;
// 		}
// 		let formattedParams;
// 		try {
// 			formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/dashboard-stats`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			// Check if error is retryable and we haven't exceeded max retries
// 			if (isRetryableApiError(error, retryCount)) {
// 				console.log(`🔄 Retrying getDashboardStats (attempt ${retryCount + 1}/3)`);

// 				// Exponential backoff delay
// 				const delay = Math.min(1000 * Math.pow(2, retryCount), 5000);
// 				await new Promise(resolve => setTimeout(resolve, delay));

// 				return this.getDashboardStats(params, userRole, userContext, retryCount + 1);
// 			}

// 			throw handleApiError(error, 'getDashboardStats', formattedParams, retryCount);
// 		}
// 	}

// 	// static async getLabReports(params = {}, userRole = null, userContext = {}) {
// 	// 	if (failedMethods.has('getLabReports')) {
// 	// 		if (process.env.NODE_ENV === 'development') console.warn('Skipping getLabReports because it previously failed this session');
// 	// 		return null;
// 	// 	}
// 	// 	try {
// 	// 		const formattedParams = userRole
// 	// 			? formatReportParams(params, userRole, userContext)
// 	// 			: this._basicFormatParams(params);
// 	// 		const resp = await axiosInstance.get(`${BASE_URL}lab/getLabReports`, {
// 	// 			params: formattedParams
// 	// 		});
// 	// 		return resp.data;
// 	// 	} catch (error) {
// 	// 		throw handleApiError(error, 'getLabReports');
// 	// 	}
// 	// }

// 	static async getAppointmentTypes(params = {}, userRole = null, userContext = {}, retryCount = 0) {
// 		if (failedMethods.has('getAppointmentTypes')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getAppointmentTypes because it previously failed this session');
// 			return null;
// 		}
// 		let formattedParams;
// 		try {
// 			validateRequiredParams(params, ['startDate', 'endDate']);
// 			formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/appointment-types`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			// Check if error is retryable and we haven't exceeded max retries
// 			if (isRetryableApiError(error, retryCount)) {
// 				console.log(`🔄 Retrying getAppointmentTypes (attempt ${retryCount + 1}/3)`);

// 				// Exponential backoff delay
// 				const delay = Math.min(1000 * Math.pow(2, retryCount), 5000);
// 				await new Promise(resolve => setTimeout(resolve, delay));

// 				return this.getAppointmentTypes(params, userRole, userContext, retryCount + 1);
// 			}

// 			throw handleApiError(error, 'getAppointmentTypes', formattedParams, retryCount);
// 		}
// 	}

// 	static async getNewUsers(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getNewUsers')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getNewUsers because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/new-users`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getNewUsers');
// 		}
// 	}

// 	static async getVisitRepetitionReturn(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getVisitRepetitionReturn')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getVisitRepetitionReturn because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/visit-repetition-return`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getVisitRepetitionReturn');
// 		}
// 	}

// 	static async getPatientGrowthTrends(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getPatientGrowthTrends')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientGrowthTrends because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			validateRequiredParams(params, ['startDate', 'endDate']);
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/patient-growth-trends`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getPatientGrowthTrends');
// 		}
// 	}

// 	// New methods for missing endpoints
// 	static async getPatientVisitFrequency(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getPatientVisitFrequency')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientVisitFrequency because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			validateRequiredParams(params, ['startDate', 'endDate']);
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/patient-visit-frequency`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getPatientVisitFrequency');
// 		}
// 	}

// 	static async getPatientFollowup(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getPatientFollowup')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getPatientFollowup because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			validateRequiredParams(params, ['startDate', 'endDate']);
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/patient-followup`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getPatientFollowup');
// 		}
// 	}

// 	// Revenue and financial analytics methods
// 	static async getRevenue(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getRevenue')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getRevenue because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			validateRequiredParams(params, ['startDate', 'endDate']);
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/revenue`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getRevenue');
// 		}
// 	}

// 	static async getRefundAnalytics(params = {}, userRole = null, userContext = {}) {
// 		if (failedMethods.has('getRefundAnalytics')) {
// 			if (process.env.NODE_ENV === 'development') console.warn('Skipping getRefundAnalytics because it previously failed this session');
// 			return null;
// 		}
// 		try {
// 			validateRequiredParams(params, ['startDate', 'endDate']);
// 			const formattedParams = userRole
// 				? formatReportParams(params, userRole, userContext)
// 				: this._basicFormatParams(params);
// 			const resp = await axiosInstance.get(`${BASE_URL}reports/refund-analytics`, {
// 				params: formattedParams
// 			});
// 			return resp.data;
// 		} catch (error) {
// 			throw handleApiError(error, 'getRefundAnalytics');
// 		}
// 	}
// }

// export default ReportService;

// /**
//  * Generic helper that calls a ReportService method and returns a normalized result
//  * { success: boolean, data: any, error: Error|null }
//  * This helper does NOT change the existing ReportService methods so existing callers
//  * remain compatible. Use this when you want a consistent shape for UI code.
//  */
// export const callReport = async (methodName, ...args) => {
// 	try {
// 		const fn = ReportService[methodName];
// 		if (!fn || typeof fn !== 'function') {
// 			return { success: false, data: null, error: new Error(`Unknown report method: ${methodName}`) };
// 		}

// 		const res = await fn(...args);

// 		// If service returned an already-normalized object, pass it through
// 		if (res && typeof res === 'object' && ('success' in res || 'error' in res)) {
// 			return res;
// 		}

// 		// Null indicates the method was skipped due to previous failures
// 		if (res === null || res === undefined) {
// 			return { success: false, data: null, error: new Error('Request skipped (previous failure)') };
// 		}

// 		return { success: true, data: res, error: null };
// 	} catch (err) {
// 		// handleApiError marks the method as failed and returns an enhanced error
// 		const enhanced = handleApiError(err, methodName, args[0] || {}, 0);
// 		return { success: false, data: null, error: enhanced };
// 	}
// };

// // Convenience wrappers for common report calls returning normalized result
// export const getDashboardStatsResult = (...args) => callReport('getDashboardStats', ...args);
// export const getPatientsVTFResult = (...args) => callReport('getPatientsVTF', ...args);